import React from 'react';

export default function Header(props) {
  return (
    <h1 style={{ color: props.color }}>
      <i>Hello {props.title}!</i>
    </h1>
  );
}
